import { render, staticRenderFns } from "./TabAsignarCorreduria.vue?vue&type=template&id=77a9649e"
import script from "./TabAsignarCorreduria.vue?vue&type=script&lang=js"
export * from "./TabAsignarCorreduria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77a9649e')) {
      api.createRecord('77a9649e', component.options)
    } else {
      api.reload('77a9649e', component.options)
    }
    module.hot.accept("./TabAsignarCorreduria.vue?vue&type=template&id=77a9649e", function () {
      api.rerender('77a9649e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/constitucionsociedades/TabAsignarCorreduria.vue"
export default component.exports